import React, {useEffect, useMemo, useState} from 'react';
import {Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip, Label} from 'recharts';
import {IStoreChart} from '../../redux/staistics-dashboard/interfaces';

import '../../pages/statistics-dashboard/styles.scss';

interface IChartData {
  id: number;
  value: number;
  label: string;
}

export interface IStatisticsPieChart {
  chart: IStoreChart;
}

export const StatisticsPieChart: React.FunctionComponent<IStatisticsPieChart> = ({chart}: IStatisticsPieChart) => {
  const [chartData, setChartData] = useState<IChartData[]>([]);
  const COLORS = ['#F8454E', '#F59E0B', '#FFD569', '#2E7D32', '#2AA198',
    '#56B4E9', '#2A4B8D', '#7B61FF', '#CC79A7', '#8D6E63'];

  function storeChartToChartData(input: IStoreChart): IChartData[] {
    const {labels, series} = input;
    const len = Math.min(labels.length, series.length);

    const result: IChartData[] = [];

    for (let i = 0; i < len; i++) {
      const value = Number(series[i]);

      if (Number.isFinite(value)) {
        result.push({
          id: i,
          value,
          label: labels[i]
        });
      }
    }

    return result;
  }

  useEffect(() => {
    setChartData(storeChartToChartData(chart));
  }, [chart]);

  const total = useMemo(
    () => chartData.reduce((sum, d) => sum + (Number.isFinite(d.value) ? d.value : 0), 0),
    [chartData]
  );

  return (
    <div className="stats-pie-chart__values-pie-chart">
      <ResponsiveContainer width="100%" height={600}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            nameKey="label"
            label={(p) => (p.value ? p.value.toString() : '')}
            labelLine={false}
            innerRadius={90}
            outerRadius={150}
            dataKey="value"
            isAnimationActive={true}
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
            <Label
              value={total ? `${total}` : ''}
              position="center"
              style={{fontSize: 20, fontWeight: 600}}
            />
          </Pie>

          <Legend align="center" verticalAlign="bottom" layout="horizontal" />
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};
